// extracted by mini-css-extract-plugin
module.exports = {"html":"layout_html__6_7dp","body":"layout_body__6ji_A","mainApp":"layout_mainApp__uf207"};